module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-0 px-0",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Register")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("                                                                            \n                Registrieren zur Zeit nicht möglich  \n            ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("´ \n                "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "offset-xs6": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81934f56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/register.vue
// module id = 335
// module chunks = 0